import { dayTheme, nightTheme } from "../../appearance/Themes";
import {
  Certificate,
  CertificateDocumentPage,
  DropdownVessel,
  RequestedDoc,
} from "../../certificates/models/certificates.interfaces";
import { VesselDetails as MyVesselDetails } from "../../my-vessels/models/home.interfaces";
import { NotificationM } from "../../notifications/models/notifications.models";
import { VesselDetails as SearchVesselDetails } from "../../search-vessels/models/search.interfaces";
import { TUser } from "../types";
import { atom } from "jotai";
import { atomWithStorage, splitAtom } from "jotai/utils";

// Certificates & Documents
export const documentsAtom = atom<CertificateDocumentPage[]>([]);
export const requestedDocsAtom = atom<RequestedDoc[]>([]);
export const downloadProgressAtom = atom(0);
export const vesselDropdownInputAtom = atom<DropdownVessel>();
export const docTypesDropdownAtom = atom<string[]>([]);
export const dropdownVesselsAtom = atom<DropdownVessel[]>([]);
export const certificatesAtom = atom<{ certificate: Certificate; isChecked: boolean }[]>([]);
export const docAppendicesAtom = atom<Certificate[]>([]);
export const certificateAtomsAtom = splitAtom(certificatesAtom);
export const hasSearchedForCertificatesAtom = atom(false);

// General
export const loadingAtom = atom(false);
export const userAtom = atom<TUser>();
export const selectedVesselAtom = atom<MyVesselDetails | SearchVesselDetails | null>(null);
export const selectedVesselDetailsAtom = atom<any[] | null>(null);
export const notificationsAtom = atom<NotificationM[]>();
export const hasUWHCMessageAtom = atom<boolean>(false);
export const hasPendingKeysSecretsRotationAtom = atom<boolean>(false);
export const featureFlagsAtom = atom({
  certificates_enabled: process.env.REACT_APP_CERTIFICATES_ENABLED === "true",
  owner_rating_enabled: process.env.REACT_APP_OWNER_RATING_ENABLED === "true",
  chat_enabled: process.env.REACT_APP_CHAT_ENABLED === "true",
  opslens_enabled: process.env.REACT_APP_OPSLENS_ENABLED === "true",
  kh_repo_voyage_card_enabled: process.env.REACT_APP_KH_REPO_VOYAGE_CARD_ENABLED === "true",
  hold_cleaning_intelligence_enabled: process.env.REACT_APP_HOLD_CLEANING_INTELLIGENCE_ENABLED === "true",
});

// Day or Night Theme
export const isDarkModeAtom = atomWithStorage<boolean>("isDarkMode", false);
export const themeAtom = atom((get) => {
  const isDark = get(isDarkModeAtom);
  return isDark ? nightTheme : dayTheme;
});
